// 费用类型
export const ORDER_PRICE_TYPE = {
  1: { label: '项目费用' },
  2: { label: '平台服务费' },
  3: { label: '杂费' },
  4: { label: '综合服务费' },
  6: { label: '商务服务费' }
};

// 支付状态
export const PAY_STATUS = {
  1: {
    label: '已完成',
    value: 1,
    children: [
      { label: '手动完结', value: '1' },
      { label: '正常完结', value: '2' }
    ]
  },
  0: {
    label: '未完成',
    value: 0,
    children: [
      { label: '手动完结', value: '1' },
      { label: '正常完结', value: '2' }
    ]
  }
};

// 支付状态2
export const PAY_STATUS2 = {
  0: {
    label: '未支付',
    value: 0,
    children: [
      { label: '手动完结', value: '1' },
      { label: '正常完结', value: '2' }
    ]
  },
  1: {
    label: '支付中',
    value: 1,
    children: [
      { label: '手动完结', value: '1' },
      { label: '正常完结', value: '2' }
    ]
  },
  2: {
    label: '部分支付成功',
    value: 2,
    children: [
      { label: '手动完结', value: '1' },
      { label: '正常完结', value: '2' }
    ]
  },
  // 3: {
  //   label: '支付成功',
  //   value: 3,
  //   children: [
  //     { label: '手动完结', value: '1' },
  //     { label: '正常完结', value: '2' }
  //   ]
  // },
  4: {
    label: '支付失败',
    value: 4,
    children: [
      { label: '手动完结', value: '1' },
      { label: '正常完结', value: '2' }
    ]
  },
  5: {
    label: '无法支付',
    value: 5,
    children: [
      { label: '手动完结', value: '1' },
      { label: '正常完结', value: '2' }
    ]
  }
};
// 订单发票类型
export const ORDER_BILL_TYPE = {
  1: { label: '支付订单', value: 1 },
  // 2: { label: '综合服务费', value: 2 }, 去掉了
  3: { label: '支付订单', value: 3 },
  4: { label: '平台服务费订单', value: 4 },
  5: { label: '商务服务费订单', value: 5 }
};
